import React from 'react';
import styles from './FeatureItem.module.css';

interface FeatureItemProps {
    title: string;
    children: React.ReactNode;
    emoji?: string;
}

export const FeatureItem: React.FC<FeatureItemProps> = ({ title, children, emoji = "✨" }) => {
    return (
        <div className={styles.featureItem}>
            <div className={styles.featureEmoji}>{emoji}</div>
            <h3 className={styles.featureTitle}>{title}</h3>
            <p>{children}</p>
        </div>
    );
};